import React, { useEffect, useMemo, useRef } from 'react';
import { Grid, Typography, Box, Paper } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  LocationOn,
  FlightLand,
  FlightTakeoff,
  TransferWithinAStation,
} from '@mui/icons-material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../styles/UserStyles.css';
import '../../styles/AddCustomer.css';
import ControlledTextInputField from '../../component/ui/FormFields/ControlledTextInputField';
import CustomButton from '../../component/ui/FormFields/Button';
import {
  updateAirportRequest,
  resetAirportState,
  viewAirportRequest,
} from '../../redux/Airports/actions/airportActions';
import {
  selectCountryAirportRequest,
  selectStateRequest,
} from '../../redux/Common/selectorAction';
import { fetchAllServiceRequest } from '../../redux/Service/ServiceAction';
import { AIRPORTS } from '../../component/common/Routes/AppRoutes';
import Loading from '../../component/ui/Loading';
import StatusRadioGroup from '../../component/ui/FormFields/StatusRadioGroup';

export default function EditAirport() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
      const location = useLocation();
      const tab = location.state?.tabEdit ?? null;
       const searchQuery=location.state.searchQuery??"";
      const page= location.state?.pageEdit??null;
  const { airportId } = useParams();
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: '',
      short_name: '',
      service_ids: '',
      country_id: '',
      state_id: '',
      sgst: '',
      cgst: '',
      tax: '',
      status: '',
    },
    mode: 'onChange',
  });
  const formValue = watch();
  const {
    loading: viewLoading,
    data: airportData,
    error,
  } = useSelector((state) => state.airport.airportDetails || {});
  const user = useSelector((state) => state.auth.user);
  const updateDetails = useSelector(
    (state) => state.airport.updateAirport || {}
  );
  const airportServices = airportData?.data?.AiportServices;
  const airportServiceList = airportServices?.map((value) => {
    return {
      value: value.service_id,
      label:
        value?.Service?.arrival_departure_type !== 3
          ? `${value?.Service?.services} - ${value?.Service?.type_of_name} - ${value?.Service?.type_of_service}`
          : `${value?.Service?.services} - ${value?.Service?.type_of_name} - ${
              value?.Service?.type_of_service
            } - ${
              value?.Service?.arrival_departure_type === 3
                ? value?.Service?.transit_type_of_service
                : 'Unknown'
            }`,
      serviceType: value?.Service?.arrival_departure_type || 1,
    };
  });

  const updateLoading = updateDetails?.loading;
  const successMessage = updateDetails?.successMessage;
  const errorMessage = updateDetails?.error;
  const ServiceDetails = useSelector(
    (state) => state.services?.ServiceDetails?.data || []
  );

  const filteredServiceDetails = ServiceDetails.filter((service) => {
    if (service?.status === 1 && service?.approoved_status === 1) {
      return {
        service,
      };
    }
  });
  const serviceCount = useRef(0);
  useEffect(() => {
    if (serviceCount.current > 2) {
      setValue('service_ids', '');
    }
    serviceCount.current += 1;
  }, [formValue?.type]);

  const filterServiceBasedOnAirportType = filteredServiceDetails.filter(
    (service) => {
      if (formValue?.type?.label === 'Both') {
        return { service };
      } else if (
        formValue?.type?.label === 'International' &&
        service?.type_of_service === 'International'
      ) {
        return { service };
      } else if (
        formValue?.type?.label === 'Domestic' &&
        service?.type_of_service === 'Domestic'
      ) {
        return { service };
      }
    }
  );

  const services = filterServiceBasedOnAirportType
    .filter((service) => service.arrival_departure_type !== 3)
    .map((service) => {
      return {
        value: service.id,
        label: `${service.services} - ${service.type_of_name} - ${service.type_of_service}`,
        serviceType: service.arrival_departure_type || 1,
      };
    });

  const transitServices = filterServiceBasedOnAirportType
    .filter((service) => service.arrival_departure_type === 3)
    .map((service) => ({
      value: service.id,
      label: `${service.services} - ${service.type_of_name} - ${
        service.type_of_service
      } - ${
        service.transit_type_of_service
          ? service.transit_type_of_service
          : 'Unknown'
      }`,
      serviceType: 3,
    }));

  const allServices = [...services, ...transitServices];

  useEffect(() => {
    dispatch(resetAirportState());
  }, []);
  useEffect(() => {
    if (user.role === 'Admin') {
      if (successMessage) {
        toast.success('Airport updated Successfully', {
          position: 'top-center',
          autoClose: 3000,
          onClose: () => {
            dispatch(resetAirportState());
            navigate(AIRPORTS);
          },
        });
      }
    } else if (user.role === 'Staff') {
      if (successMessage) {
        toast.success('Send for Admin Approval', {
          position: 'top-center',
          autoClose: 3000,
          onClose: () => {
            dispatch(resetAirportState());
            navigate(AIRPORTS);
          },
        });
      }
    }
  }, [successMessage]);
  useEffect(() => {
    if (errorMessage) {
      toast.error('Failed to Update Airport', {
        position: 'top-center',
        autoClose: 3000,
        onClose: () => {
          dispatch(viewAirportRequest(airportId));
          dispatch(resetAirportState());
        },
      });
    }
  }, [errorMessage]);
  const countries = useSelector((state) => state.selector?.country?.data || []);
  const states = useSelector((state) => state.selector?.state?.data || []);

  const countryName = countries.map((country) => ({
    value: country.id,
    label: country.country_name,
  }));
  const stateName = states.map((state) => ({
    value: state.id,
    label: state.state_name,
  }));
  const airportTypeOptions = [
    { value: '1', label: 'Domestic' },
    { value: '2', label: 'International' },
    { value: '3', label: 'Both' },
  ];
  useEffect(() => {
    if (airportId) {
      dispatch(viewAirportRequest(airportId));
    }
    dispatch(selectCountryAirportRequest());
    dispatch(fetchAllServiceRequest());
  }, [dispatch, airportId]);

  useEffect(() => {
    if (airportData) {
      setValue('name', airportData.data?.name);
      setValue('short_name', airportData.data?.short_name);
      const airportTypeMapping = {
        1: 'Domestic',
        2: 'International',
        3: 'Both',
      };
      setValue('type', {
        value: airportData.data?.type,
        label: airportTypeMapping[airportData.data?.type] || 'Unknown',
      });
      setValue('vendor_id', {
        value: airportData.data?.Vendor?.id,
        label: `${airportData.data?.Vendor?.first_name} ${airportData.data?.Vendor?.last_name} - ${airportData.data?.Vendor?.vendor_serial_no}`,
      });
      setValue('service_ids', airportServiceList);
      setValue('country_id', {
        value: airportData.data?.country_id,
        label: airportData.data?.country_name,
      });
      setValue('state_id', {
        value: airportData.data?.state_id,
        label: airportData.data?.state_name,
      });
      setValue('sgst', airportData.data?.sgst);
      setValue('cgst', airportData.data?.cgst);
      setValue('tax', airportData.data?.tax);
      setValue(
        'status',
        airportData.data?.status === 1 ? 'Active' : 'Inactive'
      );

      airportData?.data?.AiportServices?.forEach((value) => {
        setValue(`price_${value?.service_id}`, value?.price);
        setValue(`arrival_description_${value?.service_id}`, value?.arrival);
        setValue(
          `departure_description_${value?.service_id}`,
          value?.departure
        );
        setValue(`transit_description_${value?.service_id}`, value?.transit);
      });
    }
  }, [airportData, setValue]);

  const countryId = formValue.country_id?.value;
  const stateCount = useRef(0);

  useMemo(() => {
    if (countryId > 0 && stateCount.current > 0) {
      setValue('state_id', '');
    }
    if (countryId > 0) {
      dispatch(selectStateRequest(countryId));
      stateCount.current += 1;
    }
  }, [countryId]);

  const status = airportData?.data?.status === 1 ? 'Active' : 'Inactive';
  const airportFields = [
    {
      name: 'name',
      label: 'Airport Name *',
      placeholder: 'Enter Airport Name',
      rules: { required: 'Airport Name is required' },
      sm: 6,
    },
    {
      name: 'short_name',
      label: 'Airport Code *',
      placeholder: 'Enter Airport Code',
      rules: {
        required: 'Airport Code is required',
        pattern: {
          value: /^[a-zA-Z0-9]{1,5}$/,
          message:
            'Airport Code must be between 1 and 5 alphanumeric characters',
        },
      },
      sm: 6,
    },
    {
      name: 'type',
      label: 'Airport Type',
      placeholder: 'Select Airport Type',
      options: airportTypeOptions,
      icon: <LocationOn />,
      rules: { required: 'Select Airport Type' },
      sm: 6,
    },

    {
      name: 'service_ids',
      label: 'Service *',
      rules: { required: 'service is required' },
      options: allServices,
      multiple: true,
      placeholder: 'Select Service ',
      sm: 6,
    },
    {
      name: 'country_id',
      label: 'Country *',
      placeholder: 'Select country',
      rules: { required: 'Country is required' },
      options: countryName,
      sm: 6,
    },
    {
      name: 'state_id',
      label: 'State *',
      placeholder: 'Select state',
      rules: { required: 'State is required' },
      options: stateName,
      sm: 6,
    },
  ];
  const indiaSpecificFields = [
    {
      name: 'sgst',
      label: 'SGST (%) *',
      placeholder: 'Enter SGST',
      type: 'number',
      rules: {
        required: 'SGST is required',
        pattern: {
          value: /^\d+(\.\d{1,2})?$/,
          message: 'SGST must be a valid percentage (e.g., 9.00)',
        },
      },
      sm: 6,
    },
    {
      name: 'cgst',
      label: 'CGST (%) *',
      placeholder: 'Enter CGST',
      type: 'number',
      rules: {
        required: 'CGST is required',
        pattern: {
          value: /^\d+(\.\d{1,2})?$/,
          message: 'CGST must be a valid percentage (e.g., 9.00)',
        },
      },
      sm: 6,
    },
  ];
  const commissionField = [
    {
      name: 'tax',
      label: 'IGST (%) *',
      placeholder: 'Enter IGST',
      type: 'number',
      rules: {
        required: 'IGST is required',
        pattern: {
          value: /^\d+(\.\d{1,2})?$/,
          message: 'IGST must be a valid percentage (e.g., 10.00)',
        },
      },
    },
  ];

  const additionalFields =
    countryId === 101 ? indiaSpecificFields : commissionField;
  const onSubmit = (data) => {
    const requestData = {
      ...data,
      type: data.type?.value,
      service_ids: data.service_ids?.map((service) => {
        const isTransit = service.serviceType === 3;
        return {
          service_id: service.value,
          price: data[`price_${service.value}`],
          arrival: isTransit
            ? ''
            : data[`arrival_description_${service.value}`] || '',
          departure: isTransit
            ? ''
            : data[`departure_description_${service.value}`] || '',
          transit: isTransit
            ? data[`transit_description_${service.value}`] || ''
            : '',
        };
      }),
      country_id: data.country_id?.value,
      state_id: data.state_id?.value,
      status: data.status === 'Active' ? '1' : '2',
    };
    dispatch(updateAirportRequest(airportId, requestData));
  };

  if (viewLoading) {
    return <Loading text='Loading Airport details...' />;
  }

  const updatedService = formValue?.service_ids;

  if (error) {
    return (
      <Box textAlign='center' py={5}>
        <Typography variant='h6' color='error'>
          {error || 'Failed to fetch airport data.'}
        </Typography>
        <CustomButton
          text='Back to Airports'
          onClick={() => navigate(AIRPORTS)}
        />
      </Box>
    );
  }

  return (
    <Box component={Paper} sx={{ margin: '30px', padding: '30px' }}>
      <Typography variant='h5' className='form-heading' mb={2}>
        Edit Airport
      </Typography>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          {airportFields?.map((field) => (
            <Grid item xs={12} sm={field.sm} key={field.name}>
              <ControlledTextInputField
                name={field.name}
                control={control}
                label={field.label}
                multiple={field.multiple}
                placeholder={field.placeholder}
                options={field.options}
                rules={field.rules}
                error={!!errors[field.name]}
                helperText={errors[field.name]?.message}
              />
            </Grid>
          ))}
          {additionalFields?.map((field) => (
            <Grid item xs={12} sm={field.sm} key={field.name}>
              <ControlledTextInputField
                name={field.name}
                control={control}
                label={field.label}
                placeholder={field.placeholder}
                rules={field.rules}
                error={!!errors[field.name]}
                helperText={errors[field.name]?.message}
              />
            </Grid>
          ))}

          {updatedService &&
            updatedService?.map((service) => {
              const isTransit = service.serviceType === 3;
              return (
                <React.Fragment key={`service-group-${service.value}`}>
                  <Grid item xs={12}>
                    <Typography
                      variant='subtitle1'
                      sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}
                    >
                      Service: {service.label}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={12} key={`price-${service.value}`}>
                    <ControlledTextInputField
                      name={`price_${service.value}`}
                      control={control}
                      label={`Price for ${service.label} *`}
                      placeholder='Enter Price'
                      type='text'
                      rules={{
                        required: 'Price is required',
                        validate: {
                          isNumber: (value) => !isNaN(value) && value !== '',
                          positive: (value) =>
                            parseFloat(value) > 0 ||
                            'Price must be greater than 0',
                        },
                      }}
                      error={!!errors[`price_${service.value}`]}
                      helperText={errors[`price_${service.value}`]?.message}
                    />
                  </Grid>

                  {isTransit ? (
                    <Grid item xs={12} sm={12}>
                      <ControlledTextInputField
                        name={`transit_description_${service.value}`}
                        control={control}
                        label='Transit Description'
                        placeholder='Enter Transit Description'
                        multiline={true}
                        startAdornment={<TransferWithinAStation />}
                        error={!!errors[`transit_description_${service.value}`]}
                        helperText={
                          errors[`transit_description_${service.value}`]
                            ?.message
                        }
                      />
                    </Grid>
                  ) : (
                    <>
                      <Grid item xs={12} sm={6}>
                        <ControlledTextInputField
                          name={`arrival_description_${service.value}`}
                          control={control}
                          label='Arrival Description'
                          placeholder='Enter Arrival Description'
                          multiline={true}
                          startAdornment={<FlightLand />}
                          error={
                            !!errors[`arrival_description_${service.value}`]
                          }
                          helperText={
                            errors[`arrival_description_${service.value}`]
                              ?.message
                          }
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <ControlledTextInputField
                          name={`departure_description_${service.value}`}
                          control={control}
                          label='Departure Description'
                          placeholder='Enter Departure Description'
                          multiline={true}
                          startAdornment={<FlightTakeoff />}
                          error={
                            !!errors[`departure_description_${service.value}`]
                          }
                          helperText={
                            errors[`departure_description_${service.value}`]
                              ?.message
                          }
                        />
                      </Grid>
                    </>
                  )}
                </React.Fragment>
              );
            })}

          <Grid item xs={12}>
            <StatusRadioGroup
              name='status'
              control={control}
              defaultValue={status}
              rules={{ required: 'Status is required' }}
            />
          </Grid>
          <Grid item xs={12}>
            <Box className='button-container'>
              <CustomButton
                variant='contained'
                className='cancel-button'
                type='button'
                text='Back'
               
                onClick={() =>  tab!==null?navigate(`/airports`,{state:{tab:tab,page:page,searchQuery:searchQuery}}):navigate(-1)}
              />
              <CustomButton
                variant='contained'
                className='success-button'
                loading={updateLoading}
                type='submit'
                text={'Submit'}
              />
            </Box>
          </Grid>
        </Grid>
      </form>
      <ToastContainer />
    </Box>
  );
}
